export default __webpack_public_path__ + "static/barbados_super_lotto-80704b726db939b59ced7f639a3e3126.png";